module.exports = "/_next/static/images/Group-4550-90cd2d91b4c693cd32e423f95bef646f.svg";